// Runs a promise (like a fetch) immediately,
// but wait at least a certain amount of time to resolve.
// Usefull for showing loading states
const delayResolve = (time: number, promises: Array<Promise<any>>) =>
  Promise.all([
    new Promise(resolve => setTimeout(resolve, time)),
    ...promises
  ]).then(([timeout, ...responses]) => responses)

// A promise that resolve after a certain amount of time
const sleep = (time: number) =>
  new Promise(resolve => setTimeout(resolve, time))

export { saferPromise } from './safer'
export { sleep, delayResolve }
